var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar',{attrs:{"description":_vm.navMsg}}),_vm._v(" "),_c('div',{staticClass:"picture-grid"},_vm._l((_vm.total_rows),function(i){return _c('div',{key:i,staticClass:"pg-row"},_vm._l((_vm.total_cols),function(j){return _c('div',{key:j,staticClass:"pg-col"},[_c('anchor-router-link',{attrs:{"to":{name: 'Projects', hash: _vm.projects[_vm.usedProjects[i-1][j-1]].hash},"scrollOptions":{
				        container: 'body',
				        duration: 700,
				        easing: 'ease',
				        offset: 0,
				        cancelable: true,
				        onStart: false,
				        onDone: false,
				        onCancel: false,
				        x: false,
				        y: true
				    }}},[_c('img',{staticClass:"picture-grid-detail",attrs:{"src":_vm.projects[_vm.usedProjects[i-1][j-1]].image}}),_vm._v(" "),_c('span',{staticClass:"picture-grid-description"},[_vm._v(_vm._s(_vm.projects[_vm.usedProjects[i-1][j-1]].title))])])],1)}),0)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5add2ed5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = null
// module chunks = 